import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RouteType } from '@/routes/type';
import { useCustomSelector } from '@/core/redux/hooks';
import { cn } from '@/app/shared/lib/utils';

interface NavItemProps {
	item: RouteType;
	isActive: boolean;
}

const NavItemComponent = ({ item, isActive }: NavItemProps) => {
	// Hooks
	const { t } = useTranslation();

	// Redux
	const { pendingEarnAction, pendingBuildAction } = useCustomSelector(
		(state) => state.user.data
	);

	const { sidebarProps, path, icon } = item;
	const displayText = sidebarProps?.displayText;

	// Determine if a pending action dot should be shown
	const showPendingAction =
		(pendingEarnAction && displayText === 'earn') ||
		(pendingBuildAction && displayText === 'build');

	return (
		<Link
			to={path}
			className={cn(
				'flex flex-col items-center gap-2 py-2 rounded-[20px] flex-1 relative',
				{ 'bg-vottun-600 shadow-lg shadow-vottun-600/50': isActive }
			)}
		>
			{showPendingAction && (
				<div className="h-2 w-2 rounded-full bg-red-600 absolute right-3 top-2"></div>
			)}

			<div className="min-h-6 flex items-center w-12 justify-center">
				{icon}
			</div>
			<p className="text-xs">{t(`nav.${displayText}`)}</p>
		</Link>
	);
};

export const NavItem = React.memo(NavItemComponent);
